import { FIELD_TYPES } from "constants/template-field-type";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Rich Text",
    fields: {
        body: {
            type: FIELD_TYPES.RICH_TEXT,
            label: "Body"
        }
    }
};
